/**
 * Chat service for article and topic discussions.
 *
 * Provides API client functions for the AI-powered chat feature.
 */

import api from './api';

/**
 * Send a chat message about an article or topic.
 *
 * @param {string} contextType - Either "article" or "topic"
 * @param {string|number} contextId - The article or topic ID
 * @param {string} message - User's message/question
 * @param {string|null} sessionId - Optional session ID for conversation continuity
 * @returns {Promise<Object>} Response with AI message and citations
 */
export const sendChatMessage = async (contextType, contextId, message, sessionId = null) => {
  const response = await api.post('/api/chat', {
    context_type: contextType,
    context_id: String(contextId),
    message,
    session_id: sessionId
  });
  return response.data;
};

/**
 * Create a new chat session.
 *
 * @returns {Promise<Object>} Response with session_id
 */
export const createChatSession = async () => {
  const response = await api.post('/api/chat/session');
  return response.data;
};

/**
 * Clear a chat session.
 *
 * @param {string} sessionId - Session ID to clear
 * @returns {Promise<Object>} Success response
 */
export const clearChatSession = async (sessionId) => {
  const response = await api.delete(`/api/chat/session/${sessionId}`);
  return response.data;
};

export default {
  sendChatMessage,
  createChatSession,
  clearChatSession
};
